import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "com-nav" }
const _hoisted_3 = { class: "analyse" }
const _hoisted_4 = { class: "analyse-head" }
const _hoisted_5 = { class: "progress-list" }
const _hoisted_6 = { class: "progress-box" }

import { ref } from 'vue'
import { useRoute } from 'vue-router'

import DataTable from '@/components/DataTable/index.vue'
import ComHeader from '@/components/ComHeader/index.vue'
import { getBusinessData, getBusinessDataAll } from '@/api/shop'
import { IBusiness } from '@/utils/interface'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const timeType = ref(0)
const analyses = ref<IBusiness[]>([])
const data = ref<IBusiness[]>([])

const titleObj = {
  mealRate: '上座率',
  turnoverRate: '翻台率',
  tableUtilization: '餐位利用率',
  orderTime: '点单时长',
  mealTime: '就餐时长',
  serveTime: '上锅时效',
  cleanTableTime: '清台时效'
}

const handleNumber = (val: string) => {
  let flag = false
  if (val.includes('%')) {
    flag = true
    val = val.substr(0, val.length - 1)
  }
  return flag ? `${val}%` : val
}

const switchHead = (index: number) => {
  if (index === timeType.value) return
  timeType.value = index
  onLoad()
}
if (route.query.timeType) {
  timeType.value = Number(route.query.timeType)
}
const onLoad = () => {
  getBusinessDataAll({
    companyId: '1',
    timeType: timeType.value,
    pageSize: 300,
    page: 1,
    shopNo: route.query.shopNo
  }).then((res: any) => {
    analyses.value = res
  })

  // getBusinessData({
  //   companyId: '1',
  //   timeType: timeType.value,
  //   pageSize: 300,
  //   page: 1,
  //   shopNo: route.query.shopNo
  // }).then((res: any) => {
  //   data.value = res
  // })
}

onLoad()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: titleObj[(_ctx.$route.params.type as string)]
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_router_link, {
          tag: "i",
          to: "/shop",
          class: "iconfont icon-dianpu"
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass({ actived: timeType.value === 0 }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchHead(0)))
      }, "今天", 2),
      _createElementVNode("a", {
        class: _normalizeClass({ actived: timeType.value === 1 }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (switchHead(1)))
      }, "近7天", 2),
      _createElementVNode("a", {
        class: _normalizeClass({ actived: timeType.value === 2 }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (switchHead(2)))
      }, "近30天", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(titleObj[(_ctx.$route.params.type as string)]) + "分析", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analyses.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "progress-item",
            key: index
          }, [
            _createElementVNode("span", null, _toDisplayString(item.shopName), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "progress-main",
                style: _normalizeStyle({ width: item[_ctx.$route.params.type as string] })
              }, null, 4)
            ]),
            _createElementVNode("span", null, _toDisplayString(handleNumber(item[_ctx.$route.params.type as string])), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(DataTable, {
      type: (_ctx.$route.params.type as string),
      "time-type": timeType.value,
      shopNo: (_unref(route).query.shopNo as string)
    }, null, 8, ["type", "time-type", "shopNo"])
  ]))
}
}

})